export default __webpack_public_path__ + "static/media/class_mission_report_image.6cd21502.png";